
import { Options, Vue } from "vue-class-component";
import MainLayout from "@/layouts/MainLayout/MainLayout.vue";
import SideMenu from "@/components/SideMenu/SideMenu.vue";
import Breadcrumb from "@/components/Breadcrumb/Breadcrumb.vue";
import ThemesActionButton from "@/components/ThemesActionButton/ThemesActionButton.vue";
import FloatingActionButton from "@/components/FloatingActionButton/FloatingActionButton.vue";
import BaseModal from "@/components/BaseModal/BaseModal.vue";
import MemorialAudio from "@/components/MemorialAudio/MemorialAudio.vue";
import MemorialText from "@/components/MemorialText/MemorialText.vue";
import MemorialVideo from "@/components/MemorialVideo/MemorialVideo.vue";
import { ToastStore, ModalStore, DataStore, EventStore } from "@/store/index";
import { ITestimonial, ITheme } from "@/models/vimy.models";
import BusEvent from "../../../../shared/js/BusEvent";
import CreditModal from "@/components/CreditModal/CreditModal.vue";
import ShareTestimonyModal from "@/components/ShareTestimonyModal/ShareTestimonyModal.vue";
import { TestimonialSteps } from "@/components/ShareTestimonyModal/ShareTestimonyModal.ts.vue";

declare var webpackHotUpdate: any;

@Options({
  components: {
    MainLayout,
    SideMenu,
    Breadcrumb,
    ThemesActionButton,
    FloatingActionButton,
    BaseModal,
    MemorialAudio,
    MemorialText,
    MemorialVideo,
    CreditModal,
    ShareTestimonyModal
  },
  props: {},
})
export default class DevPage extends Vue {
  testimonial!: ITestimonial;
  showShareTestimonial: boolean = false;
  recording: boolean = false;
  showEndingExperience: boolean = false;
  breadCrumbVisibility: boolean = true;
  otherThemesVisibility: boolean = false;
  shareTestimonialVisibility: boolean = false;
  shareSubmit: boolean = false;
  openWithBusEvent: boolean = false;
  blockCloseModal: boolean = true;
  isThemeSelection: boolean = false;
  enablePrevButton: boolean = true;
  enableNextButton: boolean = true;
  displayPrevNext: boolean = true;

  //show: boolean = false;

  currentThemeIndex: number = -1;
  dataUnwatch!: Function;
  modalOpenUnwatch!: Function;
  breadCrumbVisibilityUnwatch!: Function;
  otherThemesVisibilityUnwatch!: Function;
  shareTestimonialVisibilityUnwatch!: Function;

  themeChangeUnwatch!: Function;
  theme: ITheme | null = null;
  delayedToggleShowShareBtn: boolean = false;

  get isAllowedToExit() {
    if (this.recording || this.blockCloseModal) {
      return false;
    }
    return true;
  }

  get hasAnyModalOpen() {
    const modals = this.modals;
    if (!modals) {
      return this.showShareTestimonial;
    }

    return (
      modals.filter((modal) => modal.show).length > 0 ||
      this.showShareTestimonial
    );
  }

  get showShareTestimonialBtn() {
    return (
      this.breadCrumbVisibility &&
      this.shareTestimonialVisibility &&
      !this.showShareTestimonial
    );
  }

  get modals() {
    if (!this.theme) {
      return [];
    }
    return Object.values(this.theme.testimonials).filter(
      (t) => t.langs.findIndex((t2) => t2 == this.$i18n.locale) != -1
    );
  }

  get isDev() {
    return typeof webpackHotUpdate !== "undefined";
  }

  openModal(id: number) {
    if (!this.theme) {
      return;
    }

    const testimonial = Object.values(this.theme.testimonials).find(
      (t) => t.id == id
    );

    if (testimonial != null) {
      testimonial.show = true;
    }
  }

  onClosed(id: number) {
    if (!this.theme) {
      return;
    }

    for (let modal of Object.values(this.theme.testimonials)) {
      modal.show = false;
    }

    EventStore.triggerModalClosed(id);

    // if duration is adjusted please change the &.modal-leave-active animation duration in BaseModal.scss
    setTimeout(() => {
      const event = new BusEvent(BusEvent.EVENTS.TESTIMONIAL_IS_OFFSCREEN);
      document.dispatchEvent(event);
    }, 1000);
  }

  clearStorage() {
    localStorage.clear();
  }

  openShareTestimonial() {
    this.shareSubmit = false;
    this.showShareTestimonial = true;

    const ev = new BusEvent(BusEvent.EVENTS.ON_SHARE_TESTIMONIAL);
    document.dispatchEvent(ev);
  }

  openShareTestimonialWithEventBus() {
    const ev = new BusEvent(BusEvent.EVENTS.SHARE_TESTIMONIAL);
    document.dispatchEvent(ev);
  }

  onShareTestimonialClose() {
    this.openWithBusEvent = false;
    this.showShareTestimonial = false;
    //console.log('close called!');
    this.delayedToggleShowShareBtn = true;
    setTimeout(() => {
      this.delayedToggleShowShareBtn = false;
    }, 3.5 * 1000);

    if (!DataStore.finishExperience)
    {
      this.showShareTestimonialButton();
    }
  }

  openEndExperienceCredit() {
    const ev = new BusEvent(BusEvent.EVENTS.OUTRO_2D_FINISHED); // SHOW_END_CREDITS
    document.dispatchEvent(ev);
  }

  openToast() {
    ToastStore.sendMessage({
      message: "Hello World!",
    });
  }

  checkModalStatus() {
    const element = document.body;
    if (!element) {
      return;
    }

    if (this.hasAnyModalOpen) {
      if (!element.classList.contains("modal-open")) {
        element.classList.add("modal-open");
      }

      return;
    }

    if (element.classList.contains("modal-open")) {
      element.classList.remove("modal-open");
    }
  }

  activated() {
    this.$watch(
      () => this.hasAnyModalOpen,
      (value: boolean, legacyValue: boolean) => {
        this.checkModalStatus();
      }
    );

    this.$watch(
      () => this.showShareTestimonial,
      (value: boolean) => {
        this.checkModalStatus();

/*
this.breadCrumbVisibility &&
      this.shareTestimonialVisibility &&
      !this.showShareTestimonial &&
      */
      }
    );

    document.addEventListener(BusEvent.EVENTS.SHARE_TESTIMONIAL, (event) => {
      const ev = event as BusEvent;
      this.openWithBusEvent = true;
      this.showShareTestimonial = true;

      const eventUI = new BusEvent(BusEvent.EVENTS.PLAY_SOUND, {
        key: "VM_H_1_",
        loop: false,
        group: "UI",
      });
      document.dispatchEvent(eventUI);
    });

    document.addEventListener(
      BusEvent.EVENTS.THEMES_SELECTION_DISPLAYED,
      (event) => {
        const ev = event as BusEvent;

        this.isThemeSelection = ev.options.visibility;
      }
    );

    document.addEventListener(
      BusEvent.EVENTS.ENABLE_DISABLE_PREV_NEXT_BUTTON,
      (event) => {
        const ev = event as BusEvent;

        this.enablePrevButton = ev.options.prev;
        this.enableNextButton = ev.options.next;

        this.displayPrevNext = !ev.options.hideButton;
      }
    );

    document.dispatchEvent(new BusEvent(BusEvent.EVENTS.GET_THEME_PREV_NEXT)); //we need to know if the prev and next button need to be displayed

    /*setTimeout(() => {
     const ev = new BusEvent(BusEvent.EVENTS.SEND_TO_CREDITS);
     document.dispatchEvent(ev);
     }, 3000);*/

    this.modalOpenUnwatch = ModalStore.$watch(
      (t) => t.opens,
      (value, _) => {
        this.openModal(ModalStore.id);
      }
    );

    this.themeChangeUnwatch = DataStore.$watch(
      (t) => t.theme,
      (value, _) => {
        this.theme = value;
      }
    );

    this.breadCrumbVisibilityUnwatch = DataStore.$watch(
      (t) => t.breadcrumbVisibility,
      (value, _) => {
        this.breadCrumbVisibility = value;
      }
    );

    this.otherThemesVisibilityUnwatch = DataStore.$watch(
      (t) => t.otherThemesVisibility,
      (value, _) => {
        this.otherThemesVisibility = value;
      }
    );

    this.shareTestimonialVisibility = DataStore.shareTestimonialVisibility;
    this.shareTestimonialVisibilityUnwatch = DataStore.$watch(
      (t) => t.shareTestimonialVisibility,
      (value, _) => {
        this.shareTestimonialVisibility = value;
      }
    );
  }

  onShareStep(step: TestimonialSteps) {
    if (step === "intro" || step === "confirmation") {
      this.blockCloseModal = true;
      return;
    }

    this.blockCloseModal = false;
  }

  devSetTheme() {
    const eventThemeSet = new BusEvent(BusEvent.EVENTS.CHANGE_THEME, {
      id: 1,
    });

    document.dispatchEvent(eventThemeSet);
  }

  showBreadcrumb() {
    const eventThemeSet = new BusEvent(BusEvent.EVENTS.BREADCRUMB_VISIBILITY, {
      visibility: true,
    });

    document.dispatchEvent(eventThemeSet);
  }

  hideBreadcrumb() {
    const eventThemeSet = new BusEvent(BusEvent.EVENTS.BREADCRUMB_VISIBILITY, {
      visibility: false,
    });

    document.dispatchEvent(eventThemeSet);
  }

  showOtherThemes() {
    const eventThemeSet = new BusEvent(
      BusEvent.EVENTS.OTHER_THEMES_VISIBILITY,
      {
        visibility: true,
      }
    );

    document.dispatchEvent(eventThemeSet);
  }

  showShareTestimonialButton() {
    const eventThemeSet = new BusEvent(
      BusEvent.EVENTS.SHARE_TESTIMONIAL_VISIBILITY,
      {
        visibility: true,
      }
    );

    document.dispatchEvent(eventThemeSet);
  }

  deactivated() {
    if (typeof this.modalOpenUnwatch === "function") {
      this.modalOpenUnwatch();
    }

    if (typeof this.themeChangeUnwatch === "function") {
      this.themeChangeUnwatch();
    }

    if (typeof this.breadCrumbVisibilityUnwatch === "function") {
      this.breadCrumbVisibilityUnwatch();
    }

    if (typeof this.otherThemesVisibilityUnwatch === "function") {
      this.otherThemesVisibilityUnwatch();
    }

    if (typeof this.shareTestimonialVisibilityUnwatch === "function") {
      this.shareTestimonialVisibilityUnwatch();
    }
  }

  recordingStatusChanged(value: boolean) {
    this.recording = value;
  }

  onShareSubmit() {
    this.shareSubmit = true;
  }

  showPrev() {
    const event = new BusEvent(BusEvent.EVENTS.CLICK_THEME_PREV_NEXT, {
      direction: "prev",
    });

    document.dispatchEvent(event);

    const eventUI = new BusEvent(BusEvent.EVENTS.PLAY_SOUND, {
      key: "VM_K_3_",
      loop: false,
      group: "UI",
    });
    document.dispatchEvent(eventUI);
  }

  showNext() {
    const event = new BusEvent(BusEvent.EVENTS.CLICK_THEME_PREV_NEXT, {
      direction: "next",
    });

    document.dispatchEvent(event);

    const eventUI = new BusEvent(BusEvent.EVENTS.PLAY_SOUND, {
      key: "VM_K_3_",
      loop: false,
      group: "UI",
    });
    document.dispatchEvent(eventUI);
  }
}
